import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { GeometergeschaeftSucheStandardComponent } from './geometergeschaeft-suche-standard/geometergeschaeft-suche-standard.component';
import { TranslatePipe } from '@ngx-translate/core';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { SearchStateService } from '../../../shared/services/search-state.service';

@Component({
  selector: 'cap-geometergeschaeft-suche',
  templateUrl: './geometergeschaeft-suche.component.html',
  styleUrls: ['./geometergeschaeft-suche.component.scss'],
  imports: [ContentHeaderComponent, TitleComponent, GeometergeschaeftSucheStandardComponent, TranslatePipe]
})
export class GeometergeschaeftSucheComponent implements OnInit {
  @ViewChild('navset', { static: true })
  ngbNav: NgbNav;

  searchMode: string;

  constructor(private stateService: SearchStateService) {}

  ngOnInit() {
    this.searchMode = this.stateService.lastSearchMode || 'searchStandard';
  }
}
